import { TaskDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityFeaturedList } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { toFeatured$ } from '../../serializer/featured';

@Component({
    components: {
        sEntityFeaturedList: EntityFeaturedList,
    },
    props: ['targetRouteName'],
    template: require('./task-featured-list.html'),
})
export class TaskFeaturedList extends ReactiveVue {
    public $taskDataStore: TaskDataStore;
    public featuredStates = TaskDataStore.featuredStates;
    public sortFields = TaskDataStore.sortFields;
    public serializer = toFeatured$;
}
